import React from 'react';

/**
 * Shared icons for the DO custom-offer BrandedAlertModal popups (T2-6186) so the
 * expired / no-longer-available / resubmit-sent modals match the house style
 * (header label icon + centered circular illustration), like PostShiftModal.
 */

// Clock — "offer timed out / expired"
export const OfferClockIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Calendar with a slash — "no longer available / withdrawn"
export const OfferUnavailableIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <rect x="3" y="5" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M9 14l6 4M15 14l-6 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// Check / paper-plane feel — "resubmit request sent"
export const OfferSentIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8.5 12.5l2.5 2.5 4.5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
